import { Component,EventEmitter,Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-solution-navcard',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './solution-navcard.component.html',
  styleUrl: './solution-navcard.component.scss'
})
export class SolutionNavcardComponent {
   @Output() close = new EventEmitter<void>();

     constructor(private router: Router) {}

  closeCard() {
    this.close.emit();
  }

  navigateTo(path: string) {
    this.close.emit(); 
    this.router.navigate([`/${path}`]);
  }

}
